import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-fit-content flex flex-col gap-2" }
const _hoisted_2 = { class: "w-full flex flex-row gap-4" }
const _hoisted_3 = ["onUpdate:modelValue", "onInput", "onKeyup"]

import { computed, ref } from "vue"
  import { each } from "lodash"
  import inputVue from "./InputTemplate.vue"

  interface Props {
    modelValue: any
    name: string
    disabled?: boolean
    id?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SixdigitCode',
  props: {
    modelValue: null,
    name: null,
    disabled: { type: Boolean },
    id: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
    modelValue: any
    name: string
    disabled?: boolean
    id?: string
  }

  

  
  const digits = ref<any[]>([null, null, null, null, null, null])
  const refDigits = ref<HTMLInputElement[]>([])
  const model = computed({
    get: () => {
      if (props.modelValue) {
        const toString = String(props.modelValue)
        return toString || ""
      } else {
        return ""
      }
    },
    set: (val) => {
      emit("update:modelValue", parseInt(val, 10) || null)
    },
  })

  /**
   * validate value
   * @param index - location of input
   */
  const checkValue = (index: number) => {
    const currentIndex = index as keyof typeof digits.value
    const value = parseInt(digits.value[currentIndex], 10)
    if (value >= 0) {
      digits.value[currentIndex] = value
      if (value < 0) {
        digits.value[currentIndex] = null
      } else if (value > 9) {
        digits.value[currentIndex] = parseInt(String(digits.value[currentIndex] as number).slice(1), 10)
      } else if (refDigits.value[(index + 1) as keyof typeof refDigits.value]) {
        ;(refDigits.value[(index + 1) as keyof typeof refDigits.value] as HTMLInputElement).focus()
      }
    } else {
      digits.value[currentIndex] = null
    }
    model.value = digits.value.join("")
  }

  /**
   * delete input
   * @param index- location to remove
   */
  const onDelete = (index: number) => {
    const currentIndex = index as keyof typeof digits.value
    const value = parseInt(digits.value[currentIndex], 10)
    if (!value && index > 0 && refDigits.value[(index - 1) as keyof typeof refDigits.value]) {
      ;(refDigits.value[(index - 1) as keyof typeof refDigits.value] as HTMLInputElement).focus()
    }
  }
  /**
   * on paste on input
   */
  const onPaste = (event: ClipboardEvent) => {
    event.preventDefault()
    const value = event.clipboardData.getData("text")
    each(value.split("").splice(0, 6), (val, index) => {
      const inputVal = parseInt(val, 10)
      if (inputVal > -1) {
        digits.value[index] = val
        checkValue(index)
      }
    })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(digits.value, (digit, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("input", {
          key: `digit_${index}`,
          ref_for: true,
          ref_key: "refDigits",
          ref: refDigits,
          "onUpdate:modelValue": ($event: any) => ((digits.value[index]) = $event),
          class: "h-[45px] w-[45px] rounded-xl focus:ring-4 focus:ring-primary-violet outline-none transition ease-out duration-200 bg-secondary-violet text-center text-3xl font-bold text-white",
          onInput: ($event: any) => (checkValue(index)),
          onKeyup: _withKeys(($event: any) => (onDelete(index)), ["delete"]),
          onPaste: onPaste
        }, null, 40, _hoisted_3)), [
          [_vModelText, digits.value[index]]
        ])
      }), 128))
    ]),
    _createVNode(inputVue, {
      id: props.id,
      modelValue: _unref(model),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      name: props.name,
      type: "text",
      "input-class": "hidden"
    }, null, 8, ["id", "modelValue", "name"])
  ]))
}
}

})